<div class="rs-flex-row">
  <div class="rs-flex-columns small-12">
    <dl data-accordion="" class="accordion" role="list">
      <dd role="listitem">
        <div class="rs-accordion-heading" role="heading" aria-level="3">
          <a
            href="#"
            role="button"
            id="ac-98167dc57b8a4fefba027ff9d7d7e540"
            aria-controls="ac-98167dc57b8a4fefba027ff9d7d7e540-content"
            aria-expanded="true"
            class="rs-expanded"
          >
            <i class="rs-icon-accordion" aria-hidden="true"></i
            >{{ 'cybercare.coverage.included.title' | translate }}
          </a>
        </div>
        <div
          class="content"
          id="ac-98167dc57b8a4fefba027ff9d7d7e540-content"
          role="region"
          aria-labelledby="ac-98167dc57b8a4fefba027ff9d7d7e540"
          style="display: block"
        >
          <div
            data-cy="cybercareIncludedSection"
            class="row"
            [innerHTML]="'cybercare.coverage.included.content' | translate: true"
          ></div>
          <p [innerHTML]="'cybercare.coverage.included2.content' | translate: true"></p>
        </div>
      </dd>
    </dl>
    <dl data-accordion="" class="accordion" role="list">
      <dd role="listitem">
        <div class="rs-accordion-heading" role="heading" aria-level="3">
          <a
            href="#"
            role="button"
            id="ac-b0ec43691a5f47f6aa76ee4335a08670"
            aria-controls="ac-b0ec43691a5f47f6aa76ee4335a08670-content"
            aria-expanded="true"
            class="rs-expanded"
          >
            <i class="rs-icon-accordion" aria-hidden="true"></i
            >{{ 'cybercare.coverage.excluded.title' | translate }}
          </a>
        </div>
        <div
          class="content"
          id="ac-b0ec43691a5f47f6aa76ee4335a08670-content"
          role="region"
          aria-labelledby="ac-b0ec43691a5f47f6aa76ee4335a08670"
          style="display: block"
        >
          <div
            data-cy="cybercareExcludedSection"
            class="row"
            [innerHTML]="'cybercare.coverage.excluded.content' | translate: true"
          ></div>
          <p [innerHTML]="'cybercare.coverage.excluded2.content' | translate: true"></p>
        </div>
      </dd>
    </dl>
  </div>
</div>
